<!--
📌 Componente: VitrineReparaturModal.vue
📂 Caminho: src/components/VitrineReparaturModal.vue
📝 Descrição: Modal simples para informar que nenhum reparo foi
  localizado para o ID do produto digitado. Mostra o ID consultado e
  um botão para fechar.

👁️ Interface e Interação com o Usuário:
  - Overlay clicável
  - Título e mensagem com o ID consultado
  - Botão único para fechar
  - Fechar via tecla ESC

📥 Entrada (Props):
  - `title` (String) - Título (default: 'Produto não localizado')
  - `productId` (String) - ID consultado
  - `message` (String) - Mensagem adicional (opcional)

📤 Saída (Emits):
  - `close` - Emitido ao fechar o modal

🔗 Dependências:
  - **Componentes Vue:** nenhum
  - **Utilitários JS:** nenhum
  - **Backend:** nenhum
  - **Bibliotecas externas:** nenhuma
-->
<template>
  <div
    v-if="isVisible"
    class="fixed inset-0 z-[9999] flex items-center justify-center bg-cinza-900/50"
    role="dialog"
    aria-label="Produkt nicht gefunden"
    aria-modal="true"
    @keydown.esc.prevent.stop="onEsc"
  >
    <div
      class="bg-branco rounded shadow-xl w-full max-w-md mx-4 overflow-hidden"
      role="document"
      tabindex="0"
      ref="panel"
      @click.stop
    >
      <header
        class="px-5 py-4 border-b border-cinza-200 flex items-center justify-between bg-branco"
      >
        <h2 class="text-lg font-semibold text-azul-profundo">
          {{ title || "Produkt nicht gefunden" }}
        </h2>

        <button
          class="p-2 rounded-full text-azul-profundo hover:bg-cinza-claro focus:outline-none focus:ring-2 focus:ring-azul-profundo"
          type="button"
          aria-label="Schließen"
          @click="close"
        >
          <!-- Ícone fechar (Heroicons Outline - inline) -->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </header>

      <section class="px-5 py-4 bg-branco">
        <p class="text-azul-profundo">
          Für die Produkt-ID
          <strong class="font-mono text-cinza-900">{{ productId }}</strong>
          wurden keine Reparaturen gefunden.
        </p>
        <p v-if="message" class="text-texto-secundario text-sm mt-2">
          {{ message }}
        </p>
      </section>

      <footer
        class="px-5 py-4 border-t border-cinza-200 flex justify-end bg-branco"
      >
        <button
          type="button"
          class="px-4 py-2 bg-amarelo-profundo text-branco rounded hover:bg-amarelo-profundo/90 focus:outline-none focus:ring-2 focus:ring-azul-profundo tracking-wide text-sm"
          @click="close"
        >
          {{ $t("vitrine.common.close") }}
        </button>
      </footer>
    </div>

    <!-- Overlay fecha modal -->
    <div class="absolute inset-0" @click="close" />
  </div>
</template>

<script>
export default {
  name: "VitrineReparaturModal",
  props: {
    title: { type: String, default: "Produkt nicht gefunden" },
    productId: { type: String, default: "" },
    message: { type: String, default: "" },
  },
  emits: ["close"],
  data() {
    return { isVisible: false };
  },
  methods: {
    show() {
      this.isVisible = true;
      this.$nextTick(() => {
        if (this.$refs.panel && this.$refs.panel.focus)
          this.$refs.panel.focus();
      });
      try {
        document.body.style.overflow = "hidden";
      } catch (_) {
        /* ignore */
      }
    },
    hide() {
      this.isVisible = false;
      try {
        document.body.style.overflow = "";
      } catch (_) {
        /* ignore */
      }
    },
    close() {
      this.hide();
      this.$emit("close");
    },
    onEsc() {
      this.close();
    },
  },
  mounted() {
    window.addEventListener("keydown", this.onEsc);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.onEsc);
    try {
      document.body.style.overflow = "";
    } catch (_) {
      /* ignore */
    }
  },
};
</script>

<style scoped>
/* Estilo concentrado nas classes utilitárias */
</style>
